import { Button } from "@mui/material";
import type React from "react";
import { useNavigate } from "react-router-dom";
import type { NavigationLinks } from "types";
import LocalizationUtils from "utils/localization-utils";
import NavigationUtils from "utils/navigation-utils";

/**
 * Component properties
 */
interface Props {
  navigation: NavigationLinks
  currentNavigation?: NavigationLinks;
}

/**
 * Draft editor screen component
 */
const NavigationLink: React.FC<Props> = ({
  navigation,
  currentNavigation
}) => {
  const navigate = useNavigate();
  const [ title ] = LocalizationUtils.getLocalizedNavigationLink(navigation);
  const match = currentNavigation === navigation;
  const color = match ?
    "#14503c" :
    "#4d4d4d";

  /**
   * Component render
   */
  return (
    <Button
      variant="text"
      sx={{
        justifyContent: "flex-start",
        flex: "0 0 auto",
        width: { xs: "auto", sm: "100%" },
        minHeight: 36,
        px: 1.5,
        py: 1,
        borderRadius: 1,
        whiteSpace: "nowrap",
        color: color,
        lineHeight: "20px",
        fontSize: 14,
        fontWeight: match ? 500 : 400,
        backgroundColor: match ? "#e4efe9" : "transparent",
        "&:hover": {
          backgroundColor: match ? "#d8e8e0" : "#f4f6f5"
        }
      }}
      onClick={ () => navigate(NavigationUtils.getTranslatedNavigation(navigation)) }
    >
      { title }
    </Button>
  );
};

export default NavigationLink;